// extracted by mini-css-extract-plugin
export var center = "_9-2";
export var clickableRow = "_9-5";
export var expandedRow = "_9-7";
export var hoverable = "_9-4";
export var left = "_9-1";
export var right = "_9-3";
export var row = "_9-0";
export var selectedRow = "_9-6";
export var summaryRow = "_9-8";